import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}
export function Card({
  className = '',
  children,
  hover = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${hover ? 'transition-shadow hover:shadow-md' : ''} ${className}`} {...props} data-id="element-342">
      {children}
    </div>;
}
export function CardHeader({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`p-6 pb-3 ${className}`} {...props} data-id="element-343">
      {children}
    </div>;
}
export function CardContent({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`p-6 pt-0 ${className}`} {...props} data-id="element-344">
      {children}
    </div>;
}
export function CardFooter({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`p-6 pt-0 flex items-center ${className}`} {...props} data-id="element-345">
      {children}
    </div>;
}